/* eslint-disable no-undef */
(function (root, factory) {
    if (typeof module === 'object' && module.exports) {
        module.exports = factory(
            require('backbone'),
            require('../utils/fp_utils'),
            require('../views/fp_font_view'),
        );
    } else if (typeof define === 'function' && define.amd) {
        define([
            'backbone',
            '../utils/fp_utils',
            '../views/fp_font_view',
        ], factory);
    }
})(this, function (Backbone, fpUtils, FpFontView) {
    'use strict';

    var FONTS = [
        'Abadi MT Condensed Light',
        'Adobe Fangsong Std',
        'Adobe Hebrew',
        'Adobe Ming Std',
        'Agency FB',
        'Aharoni',
        'Andale Mono',
        'Andalus',
        'Angsana New',
        'AngsanaUPC',
        'Aparajita',
        'Arab',
        'Arabic Transparent',
        'Arabic Typesetting',
        'Arial Baltic',
        'Arial Black',
        'Arial CE',
        'Arial CYR',
        'Arial Greek',
        'Arial TUR',
        'Arial Hebrew',
        'Arial Narrow',
        'Arial Rounded',
        'Arial Unicode MS',
        'Arial',
        'Arno',
        'Batang',
        'BatangChe',
        'Bauhaus 93',
        'Bell MT',
        'Bitstream Vera Serif',
        'Bodoni MT',
        'Bookman Old Style',
        'Book Antiqua',
        'Braggadocio',
        'Broadway',
        'Browallia New',
        'BrowalliaUPC',
        'Calibri Light',
        'Calibri',
        'Californian FB',
        'Calisto MT',
        'Cambria Math',
        'Cambria',
        'Candara',
        'Castellar',
        'Casual',
        'Centaur',
        'Century Gothic',
        'Chalkduster',
        'Cochin',
        'Colonna MT',
        'Comic Sans MS',
        'Consolas',
        'Constantia',
        'Cooper',
        'Copperplate Gothic Light',
        'Copperplate',
        'Corbel',
        'Cordia New',
        'CordiaUPC',
        'Courier New Baltic',
        'Courier New CE',
        'Courier New CYR',
        'Courier New Greek',
        'Courier New TUR',
        'Courier New',
        'Courier',
        'DFKai-SB',
        'Damascus',
        'DaunPenh',
        'David',
        'Devanagari Sangam MN',
        'DejaVu LGC Sans Mono',
        'Desdemona',
        'Didot',
        'DilleniaUPC',
        'DIN Condensed',
        'Diwan UCAS',
        'DokChampa',
        'Dotum',
        'DotumChe',
        'Droid Serif',
        'Droid Sans Mono',
        'Droid Sans',
        'Ebrima',
        'Engravers MT',
        'Eras Bold ITC',
        'Estrangelo Edessa',
        'EucrosiaUPC',
        'Euphemia',
        'Eurostile',
        'FangSong',
        'Farah',
        'Forte',
        'Fraktur',
        'FrankRuehl',
        'Franklin Gothic Heavy',
        'Franklin Gothic Medium',
        'FreesiaUPC',
        'French Script MT',
        'Futura',
        'Gabriola',
        'Gautami',
        'Geeza Pro',
        'Geneva',
        'Georgia',
        'Gigi',
        'Gill Sans',
        'Gisha',
        'Goudy Old Style',
        'Gujarati Sangam MN',
        'Gulim',
        'GulimChe',
        'GungSeo',
        'Gungsuh',
        'GungsuhChe',
        'Gurmukhi',
        'Haettenschweiler',
        'Harrington',
        'Hei S',
        'Hei',
        'HeiT',
        'Heisei Kaku Gothic',
        'Helvetica',
        'Helvetica Neue',
        'Hiragino Sans GB',
        'Impact',
        'Informal Roman',
        'IrisUPC',
        'Iskoola Pota',
        'JasmineUPC',
        'KacstOne',
        'Kai',
        'KaiTi',
        'Kalinga',
        'Kartika',
        'Khmer UI',
        'Kino MT',
        'KodchiangUPC',
        'Kokila',
        'Kozuka Gothic Pr6N',
        'Lao UI',
        'Latha',
        'Leelawadee',
        'Levenim MT',
        'LilyUPC',
        'Lohit Gujarati',
        'Loma',
        'Lucida Bright',
        'Lucida Console',
        'Lucida Grande',
        'Lucida Fax',
        'Lucida Sans Unicode',
        'MS Gothic',
        'MS Mincho',
        'MS PGothic',
        'MS PMincho',
        'MS Reference Sans Serif',
        'MS UI Gothic',
        'MT Bold',
        'MV Boli',
        'Magneto',
        'Malgun Gothic',
        'Mangal',
        'Marlett',
        'Matura MT Script Capitals',
        'Meiryo UI',
        'Meiryo',
        'Menlo',
        'Microsoft Himalaya',
        'Microsoft JhengHei',
        'Microsoft New Tai Lue',
        'Microsoft PhagsPa',
        'Microsoft Sans Serif',
        'Microsoft Tai Le',
        'Microsoft Uighur',
        'Microsoft YaHei',
        'Microsoft Yi Baiti',
        'MingLiU',
        'MingLiU-ExtB',
        'MingLiU_HKSCS',
        'MingLiU_HKSCS-ExtB',
        'Miriam Fixed',
        'Miriam',
        'Monaco',
        'Mongolian Baiti',
        'MoolBoran',
        'New Peninim',
        'NSimSun',
        'Narkisim',
        'New York',
        'News Gothic MT',
        'Niagara Solid',
        'Nyala',
        'PMingLiU',
        'PMingLiU-ExtB',
        'Palace Script MT',
        'Palatino',
        'Palatino Linotype',
        'Papyrus',
        'Perpetua',
        'Plantagenet Cherokee',
        'Playbill',
        'Prelude Bold',
        'Prelude Condensed Bold',
        'Prelude Condensed Medium',
        'Prelude Medium',
        'PreludeCompressedWGL Black',
        'PreludeCompressedWGL Bold',
        'PreludeCompressedWGL Light',
        'PreludeCompressedWGL Medium',
        'PreludeCondensedWGL Black',
        'PreludeCondensedWGL Bold',
        'PreludeCondensedWGL Light',
        'PreludeCondensedWGL Medium',
        'PreludeWGL Black',
        'PreludeWGL Bold',
        'PreludeWGL Light',
        'PreludeWGL Medium',
        'Raavi',
        'Rachana',
        'Roboto',
        'Rockwell',
        'Rockwell Nova',
        'Rod',
        'San Francisco',
        'Sanskrit Text',
        'Sakkal Majalla',
        'Sawasdee',
        'Script MT Bold',
        'Segoe Print',
        'Segoe Script',
        'Segoe UI Light',
        'Segoe UI Semibold',
        'Segoe UI Symbol',
        'Segoe UI',
        'Shonar Bangla',
        'Showcard Gothic',
        'Shruti',
        'Silom',
        'SimHei',
        'SimSun',
        'SimSun-ExtB',
        'Simplified Arabic Fixed',
        'Simplified Arabic',
        'Snap ITC',
        'Sylfaen',
        'Symbol',
        'Tahoma',
        'Taipei',
        'Trajan Sans',
        'Times New Roman Baltic',
        'Times New Roman CE',
        'Times New Roman CYR',
        'Times New Roman Greek',
        'Times New Roman TUR',
        'Times New Roman',
        'Times',
        'TlwgMono',
        'Traditional Arabic',
        'Trebuchet MS',
        'Tunga',
        'Tw Cen MT Condensed Extra Bold',
        'Ubuntu',
        'Umpush',
        'Univers',
        'Utopia',
        'Utsaah',
        'Vani',
        'Verdana',
        'Vijaya',
        'Vladimir Script',
        'Vrinda',
        'Webdings',
        'Westminster',
        'Wide Latin',
        'Wingdings',
        'Wingdings 2',
        'Wingdings 3',
        'Yu Gothic UI',
        'Yu Gothic',
        'Zapfino',
    ];

    /**
     * Javascript-based Font Detection
     *
     * The browser has no way to explicitly enumerate a list of available fonts. We
     * have to infer it indirectly. This module will first create an absolute
     * off-screen div as a work area. During initialization, it will render three
     * "fallback" fonts in the workarea and calculate their dimensions. During, the
     * detection phase, we render a preset list of test fonts will each fallback as
     * a font-family in the work area, measure the dimensions of each. If it matches
     * none of the fallbacks' dimensions, then it didn't render using the fallback
     * font meaning the font is, in fact, installed. This technique does have the
     * possbility of having false negatives.
     */
    return Backbone.Model.extend({
        initialize: function (options) {
            this.view = new FpFontView(options);
        },

        /**
         * Detection Phase
         *
         * Loop over all preset fonts and test each one. If a font matches
         * we add the result to a modified 48-bit bloom filter. This is
         * done, because the actual list of fonts is unimportant, only that
         * that two devices have similar or differing sets of fonts.
         */
        getFeatures: function () {
            var results = [];

            this.view.setUp();
            FONTS.forEach(
                function (font, i) {
                    var match = this.view.testFont(font);

                    // A modified bloom filter. Constant parameters are chosen to
                    // to be co-prime with one another to distribute entropy across
                    // all the bits fairly.
                    results[i % 48] ^= !match;
                    results[(i * 7 + 19) % 48] ^= !match;
                    results[(i * 23 + 43) % 48] ^= !match;
                }.bind(this),
            );
            this.view.tearDown();
            return [fpUtils.packMask(results)];
        },
    });
});
